import { ActionTree } from 'vuex';
import { IDashboardActivity } from '../types/dashboard-activity';
import { IDashboardState } from './dashboard.types';
import { EDashboardAction, EDashboardMutation } from './dashboard.constants';
import { RootState } from '@/store/store';
import { DashboardService } from '@/api/dashboard/services/dashboard.service';
import { alertNamespace, EAlertAction } from '@/alert/store/alert.constants';
import { translate } from '@/helpers/translation.helper';
import bugsnagClient from '@lib-shared/bugsnag';

export const actions: ActionTree<IDashboardState, RootState> = {
  async [EDashboardAction.LoadActivities]({ commit, dispatch }, { showAll }: { showAll: boolean }) {
    try {
      const activities: IDashboardActivity[] = await DashboardService.getActivity({ showAll });
      commit(EDashboardMutation.SetActivities, activities);
    } catch (e) {
      if (bugsnagClient) {
        bugsnagClient.notify(e);
      }
      dispatch(
        `${alertNamespace}/${EAlertAction.ShowDanger}`,
        translate('could-not-load-the-data-you-requested'),
        {
          root: true,
        }
      );
    }
  },
};
